import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "../../context/TranslationContext";
import ErrorComp from "../ErrorComp";
const getFieldErrorNames = (formikErrors) => {
  const transformObjectToDotNotation = (obj, prefix = "", result = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors);
};
const ScrollToFieldError = () => {
  const { reservationSendValidationError } = useTranslation();
  const { submitCount, isValid, errors } = useFormikContext();

  useEffect(() => {
    if (isValid) return;

    const fieldErrorNames = getFieldErrorNames(errors);
    if (fieldErrorNames.length <= 0) return;

    const element = document.querySelector(
      `input[name='${fieldErrorNames[0]}']`
    );
    if (!element) return;

    // Scroll to first known error into view
    toast.error(reservationSendValidationError);
  }, [submitCount]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

const SendBtn = ({ a, reservationResult }) => {
  const { reservationSendBtnText, payNow, creditCardInstantNote } =
    useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);
  const { setFieldValue, values } = useFormikContext();

  useEffect(() => {
    if (reservationResult.apiResponse) {
      if (reservationResult.error) setIsDisabled(true);
      else setIsDisabled(false);
    } else {
      setIsDisabled(false);
    }
  }, [reservationResult]);
  return (
    <>
      <ScrollToFieldError />
      <button
        disabled={
          a.isSubmitting || Object.keys(a.errors).length > 0 || isDisabled
        }
        type="submit"
        onClick={() => {
          setFieldValue(
            "directly",
            reservationResult.BookableDirectly == "1" &&
              values.paymentMethod == 2
              ? 1
              : 0
          );
        }}
        className=" px-10 py-3 text-white font-poppins text-sm leading-9 bg-greenGra mt-6 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {reservationResult.BookableDirectly == "1" && values.paymentMethod == 2
          ? payNow
          : reservationSendBtnText}
      </button>
      {reservationResult.BookableDirectly == "1" &&
      values.paymentMethod == 1 ? (
        <ErrorComp type="warning">
          {creditCardInstantNote}
        </ErrorComp>
      ) : (
        ""
      )}
    </>
  );
};

export default SendBtn;
